import React from 'react';
import styled from 'styled-components';
import Content from 'gatsby-theme-pagebuilder/src/components/content';
import Column from 'gatsby-theme-pagebuilder/src/components/column/index';
import { apollo as mapRefinements } from 'gatsby-theme-vehicles/src/helpers/map-refinements';
import SearchProvider from 'gatsby-theme-vehicles/src/components/search';
import SearchboxComponent from 'gatsby-theme-pagebuilder/src/components/blocks/searchbox/box';

const Searchbox = ({
  // id,
  columnWidth,
  align,
  justify,
  card,
  order,
  title,
  offset,
  facets,
  refinements,
  totalCount,
  groupedOptions,
  stockPage,
}) => (
  <Column
    columnWidth={columnWidth}
    align={align}
    justify={justify}
    card={card}
    order={order}
    offset={offset}
  >
    <Content textAlign={justify}>
      <SearchProvider
        srp={stockPage.searchResultsPage}
        staticCount={totalCount}
        groupedOptions={groupedOptions}
        replaceUrl={false}
        limit={1} // we dont care about the vehicles, only get 1
        defaultWhere={mapRefinements(refinements)}
      >
        <SearchboxComponent
          columnWidth={columnWidth}
          facets={Array.from(new Set(facets.map(({ field }) => field)))}
          title={title}
          stockPage={stockPage}
        />
      </SearchProvider>
    </Content>
  </Column>
);

export default styled(Searchbox)``;
